/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum MensagensAliases {
  AUTOCOMPLETE_TIPO_COMUNICADO = 'autocomplete-tipo-comunicado',
  AVATAR_0 = 'avatar-0',
  CHECKBOX_IMPORTANTES = 'checkbox-importantes',
  CHECKBOX_NAO_LIDAS = 'checkbox-nao-lidas',
  CONTEXTUAL_BAR_0 = 'contextual-bar-0',
  DATE_FIELD_0 = 'date-field-0',
  DATE_FIELD_1 = 'date-field-1',
  DECK_MENSAGENS = 'deck-mensagens',
  FETCH_MENSAGENS = 'fetch-mensagens',
  FETCH_TIPO_COMUNICADO = 'fetch-tipo-comunicado',
  FIELD_ATE = 'field-ate',
  FIELD_DATA_LIBERACAO = 'field-data-liberacao',
  FIELD_DE = 'field-de',
  FIELD_IMPORTANTES = 'field-importantes',
  FIELD_NAO_LIDAS = 'field-nao-lidas',
  FIELD_TIPO_COMUNICADO = 'field-tipo-comunicado',
  FILTER_CONSULTA_MENSAGENS = 'filter-consulta-mensagens',
  FILTERED_LIST = 'filtered-list',
  HPMS_CUSTOM_CARD_MENSAGENS = 'hpms-custom-card-mensagens',
  HPMS_DYNAMIC_CONTENT_FIELD_STATUS = 'hpms-dynamic-content-field-status',
  MAPPER_0 = 'mapper-0',
  MAPPER_TIPO_COMUNICADO = 'mapper-tipo-comunicado',
  PANEL_MENSAGENS = 'panel-mensagens',
  TEXT_TIPO_COMUNICADO = 'text-tipo-comunicado',
}
export { MensagensAliases };
